export default "__VITE_ASSET__868e9c72__"